import { useMutation } from "@tanstack/react-query";
import { SavePlacesService } from "../../services/savedPlaces.service";

export const useSavedPlacedMutations = () => {
  const { mutate: savePlace } = useMutation<any, Error, { gymListingId: string }>({
    mutationFn: async (data: { gymListingId: string }) =>
      SavePlacesService.savePlace(data?.gymListingId),
  });

  const { mutate: deletePlace } = useMutation<any, Error, { id: string }>({
    mutationFn: async (data: { id: string }) => SavePlacesService.deletePlace(data?.id),
  });

  return {
    savePlace,
    deletePlace,
  };
};
